import { HelpToFindContentLegacy } from './help-to-find-content-legacy'

export default HelpToFindContentLegacy
